"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioList = void 0;
const react_1 = __importDefault(require("react"));
const radio_1 = require("../../../helpers/radio");
const random_1 = require("../../../helpers/random");
const ErrorText_1 = require("../../atoms/ErrorText/ErrorText");
const Label_1 = require("../../atoms/Label/Label");
const RadioItem_1 = require("../RadioItem/RadioItem");
const RadioList = ({ label, value, onChange, options, groupName, error }) => {
    const groupId = groupName || (0, random_1.randomString)();
    return (react_1.default.createElement("div", { className: "flex flex-col gap-1" },
        react_1.default.createElement(Label_1.Label, null, label),
        react_1.default.createElement("div", { className: "flex flex-col gap-8" }, options.map((opt) => (react_1.default.createElement(RadioItem_1.RadioItem, { key: (0, radio_1.getRadioItemObjectValue)(opt, 'value'), value: opt, group: groupId, groupValue: value, onChange: onChange })))),
        error && react_1.default.createElement(ErrorText_1.ErrorText, null, error)));
};
exports.RadioList = RadioList;
